<i18n src="@/locales/views/service_provider/tech_visit/query/show_tech_visit.yml" lang="yaml" ></i18n>
<i18n src="@/locales/models/tech_visit.yml" lang="yaml" ></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml" ></i18n>

<template>
  <go-back-link :text="$t('labels.go_back_link')" :name="routeName('')"
    :params="{ service_provider_id: this.serviceProviderId }">
  </go-back-link>

  <bread-crumbs :labels="[module_name, tech_visit?.ref_code]" />

  <template v-if="tech_visit">
  <div class="mt-8" v-if="tech_visit">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <dt class="label-data"> {{ $t("model.tech_visit.ref_code") }} </dt>
              <dd class="content-data"> {{ tech_visit.ref_code }} </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data"> {{ $t("model.tech_visit.registered_at") }} </dt>
              <dd class="content-data"> {{ dateFormatter(tech_visit.registered_at) }} </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data"> {{ $t("model.tech_visit.latitude") }} </dt>
              <dd class="content-data"> {{ tech_visit.latitude }} </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data"> {{ $t("model.tech_visit.longitude") }} </dt>
              <dd class="content-data"> {{ tech_visit.longitude }} </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data"> {{ $t("model.crop_field.producer_id") }} </dt>
              <dd class="content-data"> {{ tech_visit.crop_field.producer.fullname}} </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data"> {{ $t("model.tech_visit.crop_field_id") }} </dt>
              <dd class="content-data"> {{ tech_visit.crop_field?.name}} </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data"> {{ $t("model.tech_visit.next_at") }} </dt>
              <dd class="content-data"> {{ dateFormatter(tech_visit.next_at) }} </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data"> {{ $t("model.tech_visit.inspector_id") }} </dt>
              <dd class="content-data"> {{ tech_visit.inspector?.name }} </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data"> {{ $t("model.tech_visit.tech_visit_form_id") }} </dt>
              <dd class="content-data"> {{ tech_visit.tech_visit_form?.name }} </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-8" v-if="tech_visit">
    <div class="panel">
      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div v-for="question in tech_visit.tech_visit_form.tech_visit_questions" :key="question.id"
              class="sm:col-span-3">
              <dt class="label-data"> {{ question.label }} </dt>
              <em class="text-sm"> {{ question.description }} </em>
              <dd class="content-data" v-html="answerValueLabel(question)"></dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

    <div class="mt-8">
      <tech-visit-map v-if="tech_visit.latitude && tech_visit.longitude" :tech-visits="[tech_visit]">
      </tech-visit-map>
    </div>
  </template>

  <loading-message v-else></loading-message>
</template>

<script>
import Requester from "@/views/service_provider/requesters/tech_visits/query/show_tech_visit.js";
import TechVisitMap from "@/components/views/service_provider/tech_visits/query/TechVisitMap.vue"

export default {
  props: {
    serviceProviderId: { required: true },
    techVisitId: { required: true }
  },
  components: { TechVisitMap },
  data() {
    return {
      tech_visit: null
    }
  },
  methods: {
    fetchTechVisit: async function () {
      let response = await Requester.fetchTechVisit({
        serviceProviderId: this.serviceProviderId,
        techVisitId: this.techVisitId
      })
      this.tech_visit = response.data;
    },
    loadData: async function () {
      this.fetchTechVisit();
    },
    answerValueLabel: function (question) {
      switch (question.answer_type) {
        case "string_answer":
        case "number_answer":
        case "text_answer":
          return question.tech_visit_answers[0]?.tech_visit_answer_values[0]?.answer_value_label;
        case "record_answer":
          return question.tech_visit_answers[0]?.tech_visit_answer_values
            .map(answer_value => answer_value.answer_value_label)
            .join(", ");
        case "multiple_by_struct_answer":
        case "unique_by_struct_answer":
          return question.tech_visit_answers
            .map(answer => {
              return answer.tech_visit_answer_values
                .map(
                  answer_value =>
                    `${answer_value.tech_visit_indicator_option.label}: ${answer_value.answer_value_label || '-'}`
                )
                .join(", ");
            })
            .join("<br />");
      }
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.serviceProviderId,
        },
      }).then(() => {
        this.loadData();
      })
    );
  }
}
</script>
